<div>
    <div class="wrapperButton">
        <div *ngIf="!showCameraVideo" (click)="requestLargerImage()">
            <img *ngIf="document && document.thumbnail" [src]="document.thumbnail"/>
        </div>
        <div *ngIf="showCameraVideo">
            <video #videoPlayer controls *ngIf="document && document.url"></video>
            </div>
    </div>
    <div>
        <a (click)="toggleCamera()" style="cursor: pointer;">
            Switch to
            <span *ngIf="!showCameraVideo">Video</span>
            <span *ngIf="showCameraVideo">Still Images</span>
        </a>
        <a *ngIf="!showCameraVideo && document.thumbnail" (click)="requestLargerImage()" class="pull-right" style="cursor:pointer;">
            Open Larger Image
        </a>
        <a *ngIf="showCameraVideo && document.url" (click)="requestLargerVideo()" class="pull-right" style="cursor:pointer;">
            Open Larger Video
        </a>
    </div>
</div>
